import { render, staticRenderFns } from "./theme-editor.vue?vue&type=template&id=c6c57872&scoped=true"
import script from "./theme-editor.vue?vue&type=script&lang=js"
export * from "./theme-editor.vue?vue&type=script&lang=js"
import style0 from "./theme-editor.vue?vue&type=style&index=0&id=c6c57872&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c57872",
  null
  
)

export default component.exports